
































































































































































































import Component, {mixins} from 'vue-class-component';
import {AxiosResponse} from 'axios';
import DetailRow from '@/common/component/DetailRow.vue';
import {dataLoggerApi} from '@/context/data_logger/api/DataLoggerApi';
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';
import DataLoggerAutcomplete from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import {Watch} from 'vue-property-decorator';
import {notNullOrUndefined} from '@/utility/functions';
import {
  CreateDeviceFromConfigurationModel
} from "@/context/data_logger/model/CreateDeviceFromConfigurationModel";
import MeterAutocomplete from "@/general/component/form/autocomplete/MeterAutocomplete.vue";
import ModelAutocomplete from "@/general/component/form/autocomplete/ModelAutocomplete.vue";
import LocationAutocomplete from "@/general/component/form/autocomplete/LocationAutocomplete.vue";
import SnackbarMessageHandler from "@/general/component/snackbar/SnackbarMessageHandler";
import FacilityAutocomplete from "@/general/component/form/autocomplete/FacilityAutocomplete.vue";

@Component({
  components: {
    FacilityAutocomplete,
    LocationAutocomplete,
    ModelAutocomplete,
    MeterAutocomplete,
    DataLoggerAutcomplete,
    ProgressSpinnerWrapper,
    DetailRow
  }
})
export default class CreateDeviceFromConfiguration extends mixins(SnackbarMessageHandler) {

  model: CreateDeviceFromConfigurationModel | null = null;
  identifier: any = null;
  configuration: any = null;
  error = false;
  devices: [] = [];
  preview = null;
  headers = [
    {text: "Obis", value: "pars.inf"},
    {text: "Numer rejestru", value: "pars.addr"},
    {text: "Identyfikator sensora", value: "id"},
    {text: "Pomiar", value: "val"},
    {text: "Jednostka", value: "unit"},
    {text: "Mnożnik", value: "mp"}
  ];
  previewHeaders = [
    {text: "Id", value: "id"},
    {text: "Identyfikator", value: "identifier"},
    {text: "Rejestr", value: "registerNumber"},
    {text: "Obis", value: "obisNumber"},
    {text: "Aktywny", value: "active"},
    {text: "aggregatable", value: "aggregatable"},
    {text: "report", value: "report"},
    {text: "tableau", value: "tableau"},
    {text: "15min", value: "quarterlyAggregated"},
    {text: "1h", value: "hourlyAggregated"},
    {text: "1d", value: "dailyAggregated"},
    {text: "1m", value: "monthlyAggregated"},


  ];

  async created() {
    await this.fetch()
  }


  async fetch(): Promise<void> {
    const response: AxiosResponse = await dataLoggerApi.createDataLoggerFromConfigurationInitialData();
    this.model = response?.data;
  }

  @Watch("identifier")
  configurationWatchHandle(val: any): void {
    if (notNullOrUndefined(val) && this.model?.configurations) {
      this.configuration = this.model?.configurations.find((i: any): any => i.config.main.device_id === val);
      this.devices = this.configuration.devs.map((dev: any): any => ({
        ...dev,
        "registers": this.configuration.regs.filter((r: any) => r.pars?.dev === dev.id)
      }))
      this.configuration.devs = this.configuration.devs.map((dev: any): any => ({
        ...dev,
        "registers": this.configuration.regs.filter((r: any) => r.pars?.dev === dev.id)
      }))
      console.log(this.configuration);
    }
  }

  async create() {
    this.error = false;
    // for (let device of this.configuration.devs) {
    //   if (!(device.model || device.location)) {
    //     this.error = true;
    //   }
    // }
    const dataLogger = await dataLoggerApi.createDataLogger(this.configuration);
    await this.$router.push({path: `data_logger/list`});

  }

  async createPreview(): Promise<void> {
    this.error = false;
    // for (let device of this.configuration.devs) {
    //   if (!(device.model || device.location)) {
    //     this.error = true;
    //   }
    // }
    const dataLogger = await dataLoggerApi.createDataLoggerPreview(this.configuration);
    this.preview = dataLogger.data;

  }
}
